import {
  Button,
  Card,
  CardHeader,
  Input,
  Typography,
  Dialog,
  Textarea,
  Chip,
  Tooltip,
  CardBody,
  CardFooter,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import MyDropzone from "../../components/MyDropzone";
import { useParams } from "react-router-dom";
import {
  ArrowDownIcon,
  ChevronUpDownIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/solid";
import {
  getReassignedQuestionData,
  getSingleVendorData,
  submitQuestionResponse,
  uploadFiles,
} from "../../helperFunctions/apiFunction";
import toast from "react-hot-toast";
import FolderDeleteOutlinedIcon from "@mui/icons-material/FolderDeleteOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";
import LoadingButton from "../../components/Loaders/LoadingButton";

const Response = () => {
  const { refreshToken } = useAuthUserToken();
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [questionnaireData, setQuestionnaireData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [openQuestionModal, setOpenQuestionModal] = useState(false);
  const [reAssignedDialog, setReAssignedDialog] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [reAssignData, setReAssignData] = useState([]);
  const [dataUpload, setDataUpload] = useState([]);
  const [searchBy, setSearchBy] = useState("");
  const { id } = useParams();
  const [quesName, setQuesName] = useState("");
  const [uploaded, setUploaded] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [quesId, setQuesId] = useState({ quesId: "", uniqueVendorQuesId: "" });

  const [initialFormData, setInitialFormData] = useState({
    vendorId: "",
    questionnaireId: "",
    questListId: "",
    quesName: "",
    quesListName: "",
    files: "",
    response: {
      ans: "",
    },
  });
  const [formData, setFormData] = useState([]);
  const initialVendorFormData = {
    quesId: "",
    quesName: "",
    quesList: [],
  };
  const [assignVendorList, setAssignVendorList] = useState(
    initialVendorFormData
  );
  const [files, setFiles] = useState([]);

  const handleDrop = (acceptedFiles) => {
    setFiles([...files, ...acceptedFiles]);
  };
  const handleQuestionList = (item) => {
    setAssignVendorList({
      quesId: item?.id || "",
      quesName: item?.quesName || "",
      quesList: item?.quesList || [],
    });
    setOpenQuestionModal((cur) => !cur);
  };

  const uploadFile = async () => {
    setLoadingUpload(true);
    if (files.length === 0) {
      toast.error("No file selected", { className: "text-[12px]" });
      setLoadingUpload(false);
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files[]", file);
    });

    try {
      const response = await uploadFiles(refreshToken, formData);
      if (response?.code === 200 || response?.code === 201) {
        setUploaded(true);
        setDataUpload(response?.data);
        toast.success(response?.message, { className: "text-[12px]" });
      } else {
        toast.error(response?.message, { className: "text-[12px]" });
      }
    } catch (error) {
      toast.error(error.message || "Error during file upload", {
        className: "text-[12px]",
      });
      console.error("Error during file upload:", error);
    } finally {
      setLoadingUpload(false);
    }
  };

  const handleReassignedDialog = (id, vendorQuesId) => {
    setQuesId({ quesId: id, uniqueVendorQuesId: vendorQuesId });
    setReAssignedDialog((cur) => !cur);
  };

  useEffect(() => {
    setIsLoading(null);
    getReassignedQuestionData(
      refreshToken,
      id,
      quesId?.quesId,
      quesId?.uniqueVendorQuesId,
      200,
      1
    ).then((data) => {
      setReAssignData(data?.data?.results);
      setQuesName(data?.data?.results?.[0]?.quesName);
      setIsLoading(false);
    });
  }, [quesId]);

  useEffect(() => {
    setIsLoading(null);
    getSingleVendorData(refreshToken, id, 100, 1).then((data) => {
      setQuestionnaireData(data?.data?.questionnaire);
      setIsLoading(false);
    });
  }, [reloadData]);

  const handleTextAreaChange = (e, _id, index, quesListName) => {
    const { value } = e.target;
    const updatedInitialFormData = {
      vendorId: id,
      questionnaireId: assignVendorList?.quesId,
      questListId: _id,
      quesName: assignVendorList?.quesName,
      quesListName: quesListName,
      files: dataUpload,
      response: { ans: value },
    };
    setInitialFormData(updatedInitialFormData);

    setFormData((prevData) => {
      const newData = [...prevData];
      newData[index] = updatedInitialFormData;
      return newData;
    });
  };

  const reAssignedHandleTextAreaChange = (
    e,
    _id,
    quesId,
    quesListId,
    quesName,
    index,
    quesListName
  ) => {
    const { value } = e.target;
    const updatedInitialFormData = {
      vendorId: id,
      questionnaireId: quesId,
      questListId: quesListId,
      quesName: quesName,
      quesListName: quesListName,
      files: dataUpload,
      response: { ans: value },
    };
    setInitialFormData(updatedInitialFormData);

    setFormData((prevData) => {
      const newData = [...prevData];
      newData[index] = updatedInitialFormData;
      return newData;
    });
  };

  const handleReAssignCancel = () => {
    setReAssignedDialog((cur) => !cur);
    setFormData([]);
    setFiles([]);
    setDataUpload([]);
    setUploaded((cur) => !cur);
    setInitialFormData({
      vendorId: "",
      questionnaireId: "",
      questListId: "",
      quesName: "",
      quesListName: "",
      files: "",
      response: {
        ans: "",
      },
    });
    setQuesName("");
  };

  const handleCancel = () => {
    setOpenQuestionModal((cur) => !cur);
    setFormData([]);
    setFiles([]);
    setDataUpload([]);
    setUploaded((cur) => !cur);
    setIsLoadingButton(false);
    setInitialFormData({
      vendorId: "",
      questionnaireId: "",
      questListId: "",
      quesName: "",
      quesListName: "",
      files: "",
      response: {
        ans: "",
      },
    });
  };

  const validateForm = () => {
    if (formData.length === assignVendorList?.quesList.length) {
      return true;
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    files.length > 0 &&
      uploaded &&
      dataUpload.length > 0 &&
      formData.map((item) => {
        if (item?.files.length === 0) {
          item.files = dataUpload;
        }
        return item;
      });
    if (validateForm()) {
      submitQuestionResponse(refreshToken, formData)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success(response?.message, {
              className: "text-[12px]",
            });
          } else if (response.code === 400) {
            toast.error(response?.message || "Please fill all the responses", {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error(error, {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setFormData(initialFormData);
          setIsLoadingButton(false);
          setReAssignedDialog(false);
          setFormData([]);
          setFiles([]);
          setUploaded((cur) => !cur);
          setReAssignData([]);
          setDataUpload([]);
          setInitialFormData({
            vendorId: "",
            questionnaireId: "",
            questListId: "",
            quesName: "",
            quesListName: "",
            files: "",
            response: {
              ans: "",
            },
          });
          setOpenQuestionModal(false);
          setReloadData((cur) => !cur);
        });
    } else {
      console.error(
        "Form submission failed. Please fill in all the responses."
      );
      setIsLoadingButton(false);
      setFormData([]);
      setInitialFormData({
        vendorId: "",
        questionnaireId: "",
        questListId: "",
        quesName: "",
        quesListName: "",
        files: "",
        response: {
          ans: "",
        },
      });
      setOpenQuestionModal((cur) => !cur);
      setDataUpload([]);
      setUploaded((cur) => !cur);
      setFiles([]);
      toast.error("Please fill all the responses");
    }
  };

  const handleReassignedSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    const filteredData = formData
      .filter((item) => item !== null && item !== undefined)
      .map((item) => {
        if (
          files.length > 0 &&
          item?.files.length === 0 &&
          dataUpload.length > 0
        ) {
          return { ...item, files: dataUpload };
        }
        return item;
      });

    submitQuestionResponse(refreshToken, filteredData)
      .then((response) => {
        if (response?.code === 200 || response?.code === 201) {
          toast.success(response?.message, {
            className: "text-[12px]",
          });
        } else if (response.code === 400) {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        } else {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error(error, {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        setIsLoadingButton(false);
        setReAssignedDialog(false);
        setFormData([]);
        setQuesId({ quesId: "", uniqueVendorQuesId: "" });
        setQuesName("");
        setReAssignData([]);
        setInitialFormData({
          vendorId: "",
          questionnaireId: "",
          questListId: "",
          quesName: "",
          quesListName: "",
          response: {
            ans: "",
          },
        });
        setReloadData((cur) => !cur);
      });
  };

  const exportToExcel = () => {};
  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Questionnaire
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all questionnaire and their compliance against compliance
                requirements
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              {isLoading === null ? (
                <Button variant="outlined" size="sm">
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span className="sr-only">Loading...</span>
                  </div>
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={exportToExcel}
                  loading={isLoading === null ? true : false}
                >
                  <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
                </Button>
              )}
              <div className="w-full md:w-auto">
                <Input
                  label="Search"
                  value={searchBy}
                  className="focus:!border-black focus:!border-2 focus:!border-t-0"
                  onChange={(e) => setSearchBy(e.target.value)}
                  icon={<MagnifyingGlassIcon className="h-5 w-5" />}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end md:flex-row"></div>
        </CardHeader>
        <CardBody>
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {["List of Questionnaire", "Response", "Status"].map(
                  (head, index) => (
                    <th
                      key={head}
                      className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-36"
                    >
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                      >
                        {head}{" "}
                        {index !== 1 && (
                          <ChevronUpDownIcon
                            strokeWidth={2}
                            className="h-4 w-4"
                          />
                        )}
                      </Typography>
                    </th>
                  )
                )}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <tbody>
                {questionnaireData &&
                  questionnaireData.map(
                    (
                      {
                        questionnaireId,
                        isDeleted,
                        status,
                        statusChanges,
                        _id: vendorQuesId,
                      },
                      index
                    ) => {
                      const { quesName, quesList, id } = questionnaireId;
                      const isLast = index === questionnaireData.length - 1;
                      const classes = isLast
                        ? "p-4"
                        : "p-4 border-b border-blue-gray-50";
                      return (
                        <tr key={index}>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {quesName}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Button
                              variant="gradient"
                              size="sm"
                              onClick={() =>
                                status === "assigned"
                                  ? handleQuestionList({
                                      quesName,
                                      quesList,
                                      id,
                                    })
                                  : status === "reAssigned"
                                  ? handleReassignedDialog(id, vendorQuesId)
                                  : null
                              }
                              disabled={
                                status === "assigned" || status === "reAssigned"
                                  ? false
                                  : true
                              }
                              className={`${
                                status === "assigned" || status === "reAssigned"
                                  ? "cursor-pointer"
                                  : "cursor-none"
                              }`}
                            >
                              {status === "assigned" || status === "reAssigned"
                                ? "Respond"
                                : "Responded"}
                            </Button>
                          </td>
                          <td className={classes}>
                            <div className="w-max">
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={status}
                                color={
                                  status === "assigned"
                                    ? "yellow"
                                    : status === "submitted"
                                    ? "gray"
                                    : status === "reAssigned"
                                    ? "orange"
                                    : status === "reSubmitted"
                                    ? "blue-gray"
                                    : status === "rejected"
                                    ? "red"
                                    : status === "accepted"
                                    ? "green"
                                    : "black"
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
              </tbody>
            )}
          </table>
        </CardBody>
      </Card>

      {/* Open Question Modal */}
      <Dialog
        size="xl"
        open={openQuestionModal}
        handler={setOpenQuestionModal}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="mx-auto w-full p-2">
            <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
              <Typography variant="h4" color="blue-gray">
                Questionnaire Name: {assignVendorList?.quesName}
              </Typography>
              <div className="grid grid-cols-1">
                <table>
                  <thead>
                    <tr>
                      {["S.no", "List of Questions", "Responses"].map(
                        (head) => (
                          <th
                            key={head}
                            className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-28"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                            >
                              {head}
                            </Typography>
                          </th>
                        )
                      )}
                    </tr>
                  </thead>
                  {isLoading === null ? (
                    <>
                      <tbody>
                        <tr>
                          <td colSpan={3}>
                            <TableSkeleton />
                          </td>
                        </tr>
                      </tbody>
                    </>
                  ) : (
                    <>
                      <tbody>
                        {assignVendorList?.quesList &&
                          assignVendorList?.quesList.map((item, index) => {
                            const isLast =
                              index === assignVendorList?.quesList.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            const questionToRender = item?.question || "";
                            return (
                              <tr key={`${item?._id}-${index}`}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-bold"
                                  >
                                    Question{"-"}
                                    {index + 1}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-justify"
                                  >
                                    {questionToRender.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={questionToRender}
                                      />
                                    ) : (
                                      questionToRender
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Textarea
                                    label={`Response - ${index + 1}`}
                                    className="focus:!border-black focus:!border-2 focus:!border-t-0"
                                    size="lg"
                                    rows={7}
                                    name={`response-${index}`}
                                    onChange={(event) =>
                                      handleTextAreaChange(
                                        event,
                                        item?._id,
                                        index,
                                        questionToRender
                                      )
                                    }
                                    value={formData?.[index]?.response?.ans}
                                    resize={true}
                                  />
                                  {!formData?.[index]?.response?.ans && (
                                    <p className="text-red-900 text-[12px]">
                                      Response is required
                                    </p>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </>
                  )}
                </table>
                <div className="flex justify-center items-center">
                  <MyDropzone onDrop={handleDrop} />
                </div>
                <div className="w-full flex justify-between items-center py-3.5">
                  <>
                    <Typography variant="h5" color="blue-gray">
                      Selected Files:
                    </Typography>
                    <ul>
                      {files.map((file, index) => (
                        <li key={index}>{file.name}</li>
                      ))}
                    </ul>
                  </>
                  {uploaded ? (
                    <>
                      <Button
                        variant="outlined"
                        color="blue"
                        disabled={true}
                        className="cursor-not-allowed"
                      >
                        <FileUploadOutlinedIcon
                          strokeWidth={2}
                          className="h-4 w-4 mr-2"
                        />
                        File Uploaded
                      </Button>
                      <Button
                        variant="outlined"
                        color="red"
                        disabled={true}
                        className="cursor-not-allowed"
                      >
                        <FolderDeleteOutlinedIcon
                          strokeWidth={2}
                          className="h-4 w-4 mr-2"
                        />
                        Remove all Files
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        color="blue"
                        disabled={files.length > 0 ? false : true}
                        loading={loadingUpload}
                        onClick={() => uploadFile()}
                      >
                        <FileUploadOutlinedIcon
                          strokeWidth={2}
                          className="h-4 w-4 mr-2"
                        />
                        Upload Files
                      </Button>
                      <Tooltip
                        className="bg-blue-gray-500"
                        content="Remove all files"
                      >
                        <Button
                          variant="outlined"
                          color="red"
                          disabled={files.length > 0 ? false : true}
                          onClick={() => setFiles([])}
                        >
                          <FolderDeleteOutlinedIcon
                            strokeWidth={2}
                            className="h-4 w-4 mr-2"
                          />
                          Remove all Files
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2 gap-4">
              <Button variant="text" color="red" onClick={handleCancel}>
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button
                  variant="gradient"
                  type="submit"
                  color="green"
                  disabled={
                    files.length > 0 ? (uploaded ? false : true) : false
                  }
                >
                  <span>Submit</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>

      {/* open reassign dialog */}
      <Dialog
        size="xl"
        open={reAssignedDialog}
        handler={setReAssignedDialog}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleReassignedSubmit}>
          <Card className="mx-auto w-full p-2">
            <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
              <Typography variant="h4" color="blue-gray">
                Questionnaire Name: {quesName}
              </Typography>
              <div className="grid grid-cols-1">
                <table>
                  <thead>
                    <tr>
                      {["S.no", "List of Questions", "Textarea", "Status"].map(
                        (head, index) => (
                          <th
                            key={head}
                            className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                            >
                              {head}{" "}
                            </Typography>
                          </th>
                        )
                      )}
                    </tr>
                  </thead>
                  {isLoading === null ? (
                    <>
                      <tbody>
                        <tr>
                          <td colSpan={4}>
                            <TableSkeleton />
                          </td>
                        </tr>
                      </tbody>
                    </>
                  ) : (
                    <>
                      <tbody>
                        {reAssignData &&
                          reAssignData.map((item, index) => {
                            const isLast = index === reAssignData?.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            const questionToRender = item?.quesListName || "";
                            return (
                              <tr key={`${item?.id}-${index}`}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-bold"
                                  >
                                    Question{"-"}
                                    {index + 1}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-justify !w-32"
                                  >
                                    {questionToRender.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={questionToRender}
                                      />
                                    ) : (
                                      questionToRender
                                    )}
                                  </Typography>
                                </td>
                                {item?.response &&
                                item?.response?.ans &&
                                item?.response?.status === "rejected" &&
                                item?.response?.status !== "accepted" ? (
                                  <>
                                    <td className={classes}>
                                      <Textarea
                                        label={`Response - ${index + 1}`}
                                        className="focus:!border-black focus:!border-2 focus:!border-t-0"
                                        size="lg"
                                        rows={6}
                                        name={`response-${index}`}
                                        onChange={(event) =>
                                          reAssignedHandleTextAreaChange(
                                            event,
                                            item?.id,
                                            item?.questionnaireId?.id,
                                            item?.questListId,
                                            item?.quesName,
                                            index,
                                            questionToRender
                                          )
                                        }
                                        value={formData?.[index]?.response?.ans}
                                        resize={true}
                                      />
                                      {!formData?.[index]?.response?.ans && (
                                        <p className="text-red-900 text-[12px]">
                                          Response is required
                                        </p>
                                      )}
                                    </td>
                                  </>
                                ) : item?.response?.status === "accepted" ? (
                                  <>
                                    <td className={classes}>
                                      <Textarea
                                        label={`Response - ${index + 1}`}
                                        className="focus:!border-black focus:!border-2 focus:!border-t-0 opacity-80 text-opacity-80"
                                        size="lg"
                                        rows={6}
                                        value={item?.response?.ans}
                                        resize={true}
                                        disabled
                                      />
                                    </td>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <td className={classes}>
                                  <div className="w-max">
                                    <Chip
                                      variant="ghost"
                                      size="sm"
                                      value={item?.response?.status}
                                      color={
                                        item?.response?.status.toLowerCase() ===
                                        "rejected"
                                          ? "red"
                                          : item?.response?.status.toLowerCase() ===
                                            "accepted"
                                          ? "green"
                                          : "black"
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </>
                  )}
                </table>
                <div className="flex justify-center items-center">
                  <MyDropzone onDrop={handleDrop} />
                </div>
                <div className="w-full flex justify-between items-center py-3.5">
                  <>
                    <Typography variant="h5" color="blue-gray">
                      Selected Files:
                    </Typography>
                    <ul>
                      {files.map((file, index) => (
                        <li key={index}>{file.name}</li>
                      ))}
                    </ul>
                  </>
                  {uploaded ? (
                    <>
                      <Button
                        variant="outlined"
                        color="blue"
                        disabled={true}
                        className="cursor-not-allowed"
                      >
                        <FileUploadOutlinedIcon
                          strokeWidth={2}
                          className="h-4 w-4 mr-2"
                        />
                        File Uploaded
                      </Button>
                      <Button
                        variant="outlined"
                        color="red"
                        disabled={true}
                        className="cursor-not-allowed"
                      >
                        <FolderDeleteOutlinedIcon
                          strokeWidth={2}
                          className="h-4 w-4 mr-2"
                        />
                        Remove all Files
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        color="blue"
                        disabled={files.length > 0 ? false : true}
                        loading={loadingUpload}
                        onClick={() => uploadFile()}
                      >
                        <FileUploadOutlinedIcon
                          strokeWidth={2}
                          className="h-4 w-4 mr-2"
                        />
                        Upload Files
                      </Button>
                      <Tooltip
                        className="bg-blue-gray-500"
                        content="Remove all files"
                      >
                        <Button
                          variant="outlined"
                          color="red"
                          disabled={files.length > 0 ? false : true}
                          onClick={() => setFiles([])}
                        >
                          <FolderDeleteOutlinedIcon
                            strokeWidth={2}
                            className="h-4 w-4 mr-2"
                          />
                          Remove all Files
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2 gap-4">
              <Button variant="text" color="red" onClick={handleReAssignCancel}>
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button
                  variant="gradient"
                  type="submit"
                  color="green"
                  disabled={
                    files.length > 0 ? (uploaded ? false : true) : false
                  }
                >
                  <span>Submit</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>
    </div>
  );
};

export default Response;
